<template>
  <div class="ask-container" :class="{ 'disabled': disabled, 'answering': isAnswering, 'loading': isLoading, 'full-screen': fullScreen, 'show-fade': showFade }"
       @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave"
  >
    <div class="ask-wrapper">
      <div class="textarea-wrapper">
        <textarea
        ref="textarea"
        rows="1"
        v-model="question"
        :placeholder="limitReached ? $t('mine.chat.limitPlaceHolder') : $t('mine.chat.askPlaceholder')"
        @input="handleResizeTextArea"
        @keypress="handlePress"
        @focus="handleFocus"
        @blur="handleBlur"
        />
      </div>
      <div class="button-wrapper">
        <button
          :class="['send-button', { loading: isLoading || isAnswering }]"
          @click="handleSubmit"
        >
          <div v-if="isLoading || isAnswering" class="droplet_spinner">
            <div class="droplet"></div>
            <div class="droplet"></div>
            <div class="droplet"></div>
          </div>
          <i v-else class="icon icon--send-white" />
        </button>
      </div>
    </div>
    <button v-if="isLoading || isAnswering" class="pause" @click="$emit('stop')">
      <i class="icon icon--pause-answering" />
      <p>{{ $t('mine.chat.pause') }}</p>
    </button>
  </div>
</template>

<script>
export default {
  name: 'AskContainer',
  props: {
    isLoading: Boolean,
    isAnswering: Boolean,
    disabled: Boolean,
    fullScreen: Boolean,
    showFade: Boolean,
    limitReached: Boolean
  },
  data () {
    return {
      question: '',
      isFocused: false
    }
  },
  computed: {
    isDisabled () {
      return this.checkIsEmpty() || this.disabled
    }
  },
  methods: {
    handleFocus () {
      this.isFocused = true
      this.$emit('show-count')
    },
    handleBlur () {
      this.isFocused = false
      this.$emit('hide-count')
    },
    handleMouseEnter () {
      this.$emit('show-count')
    },
    handleMouseLeave () {
      if (!this.isFocused) {
        this.$emit('hide-count')
      }
    },
    handleSubmit () {
      if (this.isDisabled) return

      this.$emit('submit', { prompt: this.question })
      this.question = ''
      this.$refs.textarea.style.height = 'auto'
      // this.$refs.textarea.blur()
    },
    handleResizeTextArea () {
      this.$refs.textarea.style.height = 'auto'
      const newHeight = Math.min(this.$refs.textarea.scrollHeight, 108)
      this.$refs.textarea.style.height = newHeight + 'px'
    },
    handlePress (e) {
      if (e.keyCode !== 13) return
      if (e.shiftKey) return

      e.preventDefault()
      this.handleSubmit()
    },
    checkIsEmpty () {
      return this.question.length === 0
    }
  }
}
</script>

<style lang="scss" scoped>
.ask-container {
  position: relative;
  width: 100%;
  padding: 11px 13px 13px;
  background-color: #ECECEC;
  box-sizing: border-box;
  flex-shrink: 0;

  &.disabled {
    .ask-wrapper {
      pointer-events: none;
      .button-wrapper {
        .send-button {
          background-color: #999;
        }
      }
    }
  }

  .ask-wrapper {
    display: flex;
    align-items: flex-end;
    width: 100%;
    background-color: #111111;
    border-radius: 8px;
    box-sizing: border-box;
    box-shadow: 0px 4px 5px 0px #0000001f;

    .textarea-wrapper {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 18px;

      textarea {
        min-height: 18px;
        width: 100%;
        padding: 0;
        border: none;
        background: none;

        font-size: 16px;
        line-height: 1.2;
        text-align: left;
        outline: none;
        resize: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        color: #FFFFFF;

        &::placeholder {
          color: #BFBFBF;
        }
        &::-webkit-scrollbar {
          display: none;
        }
      }
    }
    .button-wrapper {
      padding: 11px 11px 11px 0;
      .send-button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 34px;
        height: 34px;
        padding: 2px;
        border-radius: 4px;
        background-color: $brandColor;
        &.loading {
          background-color: transparent;
        }
        .droplet_spinner {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 4px;
          .droplet {
            width: 6px;
            height: 6px;
            background-color: $brandColor;
            border-radius: 50%;
            transform-origin: center bottom;
            animation: bounce 1.2s cubic-bezier(0.3, 0.01, 0.4, 1) infinite;

            &:nth-child(1) {
              animation-delay: -0.4s;
            }
            &:nth-child(2) {
              animation-delay: -0.2s;
            }
            &:nth-child(3) {
              animation-delay: 0s;
            }
          }

          @keyframes bounce {
            100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-10px);
            }
          }
        }

      }
    }
  }

  .pause {
    position: absolute;
    top: 3px;
    right: 23px;
    transform: translateY(-100%);
    display: flex;
    align-items: center;
    gap: 4px;
    color: #7D7D7D;
    font-size: 14px;
    font-weight: 600;
    z-index: 1;
  }

  &:after {
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    width: 100%;
    height: 24px;
    background: linear-gradient(180deg, rgba(236, 236, 236, 0) 0%, #ECECEC 38.94%);
    transform: translateY(-100%);
    opacity: 0;
    transition: opacity 0.2s ease;
    pointer-events: none;
  }
  &.show-fade:after {
    opacity: 1;
  }

  &.full-screen {
    @media (min-width: 769px) {
    }
  }
}
</style>
